export const WorksheetCalculatedValuesPanelTestIds = {
  PANEL: 'worksheet-drawer.calculated-values',
  ROW: 'worksheet-drawer.calculated-values.row',
  VALUE: 'worksheet-drawer.calculated-values.value',
};
